import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cat_audio",
  "use": "icon-cat_audio-usage",
  "viewBox": "0 0 11.47 10.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.47 10.3\" id=\"icon-cat_audio\"><title>Sound</title><g id=\"icon-cat_audio_图层_2\" data-name=\"图层 2\"><g id=\"icon-cat_audio_图层_1-2\" data-name=\"图层 1\"><path d=\"M5.7,5.34a1.76,1.76,0,0,0-.55-.09A1.65,1.65,0,1,0,6.8,6.9V2.72H8.55v-1H5.83V5.39Z\" /><path d=\"M11,0H.48A.49.49,0,0,0,0,.48V9.82a.48.48,0,0,0,.48.48H11a.49.49,0,0,0,.48-.48V.48A.48.48,0,0,0,11,0ZM10.5,9.33H1V1H10.5Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol